import React from "react";
import { useLocation } from "react-router-dom";
import useAuthGlobal from "src/context/useAuthGlobal";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
import ForbiddenPage from "src/pages/403";

const getRequiredPermissions = (pathname, search) => {
  const params = new URLSearchParams(search);
  const tab = params.get("tab");

  if (pathname === "/product") {
    const status = params.get("status");
    if (status === "create") return [PERMISSIONS.CREATE_PRODUCT];
    if (status === "update") return [PERMISSIONS.UPDATE_PRODUCT];
    if (tab === "brands") return [PERMISSIONS.VIEW_BRAND];
    if (tab === "manufacturer") return [PERMISSIONS.VIEW_MANUFACTURER_ALL, PERMISSIONS.VIEW_MANUFACTURER_OWN];
    return [PERMISSIONS.VIEW_PRODUCT];
  }

  if (pathname === "/user") {
    if (["Sales", "SalesChannel", "Staff"].includes(tab)) return [PERMISSIONS.VIEW_SALES_ALL, PERMISSIONS.VIEW_SALES_OWN];
    return [PERMISSIONS.VIEW_CUSTOMER];
  }

  if (pathname === "/warehouse-management") {
    if (tab === "inventory-balance") return [PERMISSIONS.VIEW_INVENTORY_ALL, PERMISSIONS.VIEW_INVENTORY_OWN];
    return [PERMISSIONS.VIEW_WAREHOUSETRANSFEREXPORT_ALL, PERMISSIONS.VIEW_WAREHOUSETRANSFEREXPORT_OWN];
  }

  if (pathname === "/warehouse-management/inventory") {
    return [PERMISSIONS.VIEW_INVENTORY_ALL, PERMISSIONS.VIEW_INVENTORY_OWN, PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN];
  }

  if (pathname === "/warehouse-management/inventory-in") {
    return [PERMISSIONS.VIEW_WAREHOUSETRANSFERIMPORT_ALL, PERMISSIONS.VIEW_WAREHOUSETRANSFERIMPORT_OWN];
  }

  if (pathname === "/warehouse-management/batch") {
    return [PERMISSIONS.VIEW_BATCH_ALL, PERMISSIONS.VIEW_BATCH_OWN];
  }

  if (pathname === "/setting/providers") {
    return [PERMISSIONS.VIEW_PROVIDER];
  }

  if (pathname === "/setting/warehouse") {
    return [PERMISSIONS.VIEW_WAREHOUSE_ALL, PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN];
  }

  if (pathname === "/setting/transportation-provider") {
    return [PERMISSIONS.VIEW_SHIPPINGPROVIDER_ALL, PERMISSIONS.VIEW_SHIPPINGPROVIDER_OWN];
  }

  if (pathname === "/orders" || /^\/orders\/[^/]+$/.test(pathname)) {
    return [PERMISSIONS.VIEW_ORDER_ALL, PERMISSIONS.VIEW_ORDER_OWN];
  }

  if (pathname === "/order/create") {
    return [PERMISSIONS.CREATE_ORDER_ALL, PERMISSIONS.CREATE_ORDER_OWN];
  }

  if (pathname === "/bank-info") {
    return [PERMISSIONS.VIEW_BANKINFO];
  }

  return null;
};

export default function PagePermissionGuard({ children }) {
  const { pathname, search } = useLocation();
  const { meLoading, userMe } = useAuthGlobal();
  const permissionCheck = useRoleCheck();
  const requiredPermissions = getRequiredPermissions(pathname, search);

  if (!requiredPermissions) return children;
  if (meLoading || !userMe) return null;
  if (!permissionCheck(requiredPermissions)) return <ForbiddenPage />;

  return children;
}
